import { makeStyles } from '@material-ui/core/styles';
import { TextColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

export default makeStyles(
  (muiTheme) => ({
    root: {
      display: 'flex',
    },
    description: {
      '& p': {
        color: `${hexToRGBA(TextColors.light, TextOpacities.light2)} !important`,
      },
    },
  }),
  { name: 'GenToggleOption' },
);
